import React from "react";
import {
    Row,
    Col,
    Button,
    Menu,
    Dropdown
} from 'antd';

import { 
    FiBarChart,
    FiBookmark,
    FiUsers,
    FiLock
} from "react-icons/fi";

import Banner_car from '../../assets/images/car-home.png';
import Bg_dashboard from '../../assets/images/bg-dashboard.png';
import Bg_dashboard1 from '../../assets/images/topbanner.png';
import Icon_1 from '../../assets/images/icons/icon1.svg';
import Icon_2 from '../../assets/images/icons/icon2.svg';
import Icon_3 from '../../assets/images/icons/icon3.svg';
import Icon_4 from '../../assets/images/icons/icon4.svg';
import Management from '../../assets/images/management.png';
import Community from '../../assets/images/community.png';


function DashBoard() {

    return (
        <>
            <Row justify="space-around" align="middle" className="bg-section" style={{backgroundImage: `url(${Bg_dashboard1})`}}>
                <Col xs={24} sm={24} md={24} lg={24} xl={12} className="text-center pt-5">
                    <h1>The Launchpad Protocol for Everyone!</h1>
                    <p className="text-white">Launchpad helps everyone to create their own tokens and token sales in few seconds. Tokens created on PinkSale will be verified and published on explorer websites.</p>
                </Col>
            </Row>
            <Row justify="space-around" align="middle" className="row-margin" gutter={16}>
                <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                    <div className="box-icon-left">
                        <div className="box-icon">
                            <FiBarChart />
                        </div>
                        <div className="box-text">
                            <p>Total Liquidity Raised</p>
                            <h1>$5.8M</h1>
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                    <div className="box-icon-left">
                        <div className="box-icon">
                            <FiBookmark />
                        </div>
                        <div className="box-text">
                            <p>Total Projects</p>
                            <h1>124</h1>
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                    <div className="box-icon-left">
                        <div className="box-icon">
                            <FiUsers />
                        </div>
                        <div className="box-text">
                            <p>Total Participants</p>
                            <h1>5K</h1>
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                    <div className="box-icon-left">
                        <div className="box-icon">
                            <FiLock />
                        </div>
                        <div className="box-text">
                            <p>Total Values Locked</p>
                            <h1>$2.8M</h1>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row justify="space-around" align="middle" className="row-margin">
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                    <img src={Banner_car} alt="" className="img" />
                </Col>
            </Row>
            <Row justify="space-around" align="middle" className="row-margin">
                <Col xs={24} sm={24} md={24} lg={24} xl={16} className="text-center">
                    <h1>A Suite of Tools for Token Sales.</h1>
                    <p className="text-white">A suite of tools were built to help you create your own tokens and launchpads in a fast, simple and cheap way, with no prior code knowledge required and 100% decentralized!</p>
                </Col>
            </Row>
            <Row justify="space-around" align="middle" className="row-margin-normal" gutter={[16,16]}>
                <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                    <div className="box-icon-top">
                        <div className="box-icon">
                            <img src={Icon_1} alt="" />
                        </div>
                        <div className="box-text">
                            <h1>Standard</h1>
                            <p>Mint standard tokens on ETH, BSC, AVAX, Fantom, Polygon.</p>
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                    <div className="box-icon-top">
                        <div className="box-icon">
                            <img src={Icon_2} alt="" />
                        </div>
                        <div className="box-text">
                            <h1>Deflationary</h1>
                            <p>Generate deflationary tokens with tax and/or charity functions.</p>
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                    <div className="box-icon-top">
                        <div className="box-icon">
                            <img src={Icon_3} alt="" />
                        </div>
                        <div className="box-text">
                            <h1>Customization</h1>
                            <p>Create a token sale for your own custom token easily.</p>
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                    <div className="box-icon-top">
                        <div className="box-icon">
                            <img src={Icon_4} alt="" />
                        </div>
                        <div className="box-text">
                            <h1>Launchpad</h1>
                            <p>Mint standard tokens on ETH, BSC, AVAX, Fantom, Polygon.</p>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row justify="space-around" align="middle" className="row-margin">
                <Col xs={24} sm={24} md={24} lg={24} xl={16} className="text-center">
                    <h1>A Growing Protocol Ecosystem</h1>
                    <p className="text-white">We build a suite of tools for the world of decentralized finance. PinkMoon, PinkSale, PinkElon PinkLock, PinkSwap, we Pink everything!</p>
                </Col>
            </Row>
            <Row justify="space-around" align="middle" className="row-margin-normal" gutter={[16,16]}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <div className="box-icon-right">
                        <div className="box-icon">
                            <img src={Management} alt="" />
                        </div>
                        <div className="box-text">
                            <h1>Standard</h1>
                            <p>Mint standard tokens on ETH, BSC, AVAX, Fantom, Polygon.</p>
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <div className="box-icon-right">
                        <div className="box-icon">
                            <img src={Community} alt="" />
                        </div>
                        <div className="box-text">
                            <h1>Deflationary</h1>
                            <p>Generate deflationary tokens with tax and/or charity functions.</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default DashBoard;
